import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { IsUnconfirmedBackCountNdcExists } from '../../states/audits/audits.actions';
import { AuditsState } from '../../states/audits/audits.state';

@Component({
  selector: 'app-back-count-not-resolved-tooltip',
  templateUrl: './back-count-not-resolved-tooltip.component.html',
  styleUrls: ['./back-count-not-resolved-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackCountNotResolvedTooltipComponent implements OnChanges {
  @Input() locationID: string;
  @Input() drugID: string;
  @Input() imgClass: string;
  @Input() alwaysShow?: boolean = null;

  isUnconfirmedInBackCount$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  /**
   *
   */
  constructor(private store: Store) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.locationID && this.drugID && !this.alwaysShow) {
      this.store.dispatch(new IsUnconfirmedBackCountNdcExists(this.locationID, this.drugID))
      .pipe(take(1))
      .subscribe(res => {
        this.isUnconfirmedInBackCount$.next(this.store.selectSnapshot(AuditsState.response)?.value);
      })
     } else {
      this.isUnconfirmedInBackCount$.next(!!this.alwaysShow);
     }

     
  }
}
